export const styleCustom = (url, attribution) => ({
  version: 8,
  sources: {
    osm: {
      type: 'raster',
      tiles: [url],
      attribution
    },
    overlaod: {
      type: 'raster',
      tiles: [
        'https://wxs.ign.fr/1p5aupicbuq8yqdiv1gtu1kv/geoportail/wmts?layer=GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-OACI&style=normal&tilematrixset=PM&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}'
      ],
      tileSize: 256
    }
  },
  glyphs: 'https://cdn.traccar.com/map/fonts/{fontstack}/{range}.pbf',
  layers: [
    {
      id: 'osm',
      type: 'raster',
      source: 'osm'
    },
    {
      id: 'my-overlaod',
      type: 'raster',
      source: 'overlaod',
      minzoom: 6,
      maxzoom: 11
    }
  ]
});
export const styleOsm = () =>
  styleCustom(
    'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    '© <a target="_top" rel="noopener" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, © <a target="_top" rel="noopener" href="https://www.openaip.net/">openAIP</a>, © <a target="_top" rel="noopener" href="https://www.ign.fr/">IGN</a>'
  );

export const styleCarto = () => ({
  version: 8,
  sources: {
    'raster-tiles': {
      type: 'raster',
      tiles: [
        'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png',
        'https://b.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png',
        'https://c.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png',
        'https://d.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png'
      ],
      tileSize: 256,
      attribution:
        '© <a target="_top" rel="noopener" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, © <a target="_top" rel="noopener" href="https://carto.com/attribution">CARTO</a>, © <a target="_top" rel="noopener" href="https://www.openaip.net/">openAIP</a>'
    }
  },
  glyphs: 'https://cdn.traccar.com/map/fonts/{fontstack}/{range}.pbf',
  layers: [
    {
      id: 'simple-tiles',
      type: 'raster',
      source: 'raster-tiles',
      minzoom: 0,
      maxzoom: 22
    }
  ]
});

export const styleGoogleMap = () => ({
  version: 8,
  sources: {
    'raster-tiles': {
      type: 'raster',
      tiles: ['https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga'],
      tileSize: 256,
      attribution:
        '© <a target="_top" rel="noopener" href="">Google maps</a> contributors, © <a target="_top" rel="noopener" href="https://www.openaip.net/">openAIP</a>'
    }
  },
  glyphs: 'https://cdn.traccar.com/map/fonts/{fontstack}/{range}.pbf',
  layers: [
    {
      id: 'simple-tiles',
      type: 'raster',
      source: 'raster-tiles',
      minzoom: 0,
      maxzoom: 22
    }
  ]
});

export const styleSatellite = () => ({
  version: 8,
  sources: {
    'raster-tiles': {
      type: 'raster',
      tiles: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
      ],
      tileSize: 256,
      attribution:
        '© <a target="_top" rel="noopener" href="">Satellite</a> contributors, © <a target="_top" rel="noopener" href="https://www.openaip.net/">openAIP</a>'
    }
  },
  glyphs: 'https://cdn.traccar.com/map/fonts/{fontstack}/{range}.pbf',
  layers: [
    {
      id: 'simple-tiles',
      type: 'raster',
      source: 'raster-tiles',
      minzoom: 0,
      maxzoom: 22
    }
  ]
});

export const styleMapboxStreets = () => 'mapbox://styles/mapbox/streets-v11';
export const styleMapboxOutdoors = () => 'mapbox://styles/mapbox/outdoors-v12?optimize=true';
export const styleMapboxSatelliteStreets = () =>
  'mapbox://styles/mapbox/satellite-streets-v12?optimize=true';
